import { Prop, Vue } from "vue-property-decorator";
import { SupplierForm } from "./SupplierForm";
import { FormModel } from "@/service/common/entity/FormModel";
import { mergeData } from "@/utils";
export abstract class SupplierFormCtrl extends Vue {
  /** 供应商来源（入口） */
  @Prop() sourceType!: number;
  abstract formData: FormModel;
  /**
   * 获取各子表单的引用
   * 校验时将返回按顺序将错误信息滚动到视区
   * @returns
   */
  abstract getFormsRef(): SupplierForm[];
  /**
   * 校验
   * @returns
   */
  async validate(): Promise<boolean> {
    const forms: SupplierForm[] = this.getFormsRef().filter((ref) => !!ref);
    const validateRes = await Promise.all(
      forms.map((form) => {
        return form.validate && form.validate();
      })
    )
      .then((res) => res.every((r) => !!r))
      .catch(() => false);
    for (const form of forms) {
      if (form.scrollErrorIntoView()) {
        break;
      }
    }
    return !!validateRes;
  }
  patchFormData(data: FormModel) {
    // function assignObj(obj: FormModel, target: FormModel) {
    //   Object.keys(obj).forEach((key) => {
    //     if (target[key] === undefined) {
    //       Vue.set(target, key, cloneDeep(obj[key]));
    //     } else if (
    //       obj[key] &&
    //       typeof obj[key] === "object" &&
    //       typeof target[key] === "object"
    //     ) {
    //       assignObj(obj[key] as FormModel, target[key] as FormModel);
    //     } else if (obj[key] && typeof obj[key] === "object") {
    //       Vue.set(target, key, cloneDeep(obj[key]));
    //     } else {
    //       Vue.set(target, key, obj[key]);
    //     }
    //   });
    // }
    // assignObj(data, this.formData);
    mergeData(data, this.formData);
  }
}
